import { useRouteError } from 'react-router-dom'

import { ErrorState } from '@/components/patterns/states'

export function RouteError() {
  const error = useRouteError()
  return <ErrorState error={error} variant="page" onRetry={() => window.location.reload()} />
}
